function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { getUiOptions } from '../Schema/utils';
import Grid from '@material-ui/core/Grid';
const useStyles = makeStyles(theme => ({
  root: {
    position: "relative",
    width: "100%",
    padding: props => {
      return theme.spacing(props.padding);
    }
  }
}));

const LayoutGridItem = (_ref) => {
  let uiSchema = _ref.uiSchema,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["uiSchema", "children"]);

  const uiOptions = uiSchema && getUiOptions(uiSchema);
  const gridCols = props.gridCols || uiOptions && uiOptions.gridCols;

  if (gridCols && typeof gridCols === 'number' && gridCols !== 0) {
    return React.createElement(Grid, {
      item: true,
      xs: gridCols
    }, children);
  }

  if (gridCols && typeof gridCols === "object") {
    return React.createElement(Grid, _extends({
      item: true
    }, gridCols), children);
  }

  return React.createElement(Grid, {
    item: true,
    xs: 12
  }, children);
};

const LayoutGrid = ({
  grid = true,
  padding = 0,
  spacing = 2,
  alignItems,
  alignContent,
  justify,
  children
}) => {
  const classes = useStyles({
    padding
  });

  if (!grid) {
    return React.createElement("section", {
      className: classes.root
    }, children);
  }

  const items = React.Children.toArray(children);
  return React.createElement("section", {
    className: classes.root
  }, React.createElement(Grid, {
    container: true,
    alignItems: alignItems,
    alignContent: alignContent,
    justify: justify,
    spacing: spacing
  }, items.map((child, index) => {
    return React.createElement(LayoutGridItem, _extends({}, child.props, {
      key: index
    }), child);
  })));
};

export default LayoutGrid;